import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $BoxCountModuleName } from "./boxCount.types";

const { isLoading } = generateDefaultSelectors($BoxCountModuleName);

const getBoxCount = (sku: string) => (state: IState) => {
    if (!sku) return undefined;

    return getApiDataState(state, $BoxCountModuleName)?.[sku]?.data?.count;
};

export { getBoxCount, isLoading };
